import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import { inject, observer } from 'mobx-react';
import Event from './Event';
import Modal from 'react-bootstrap4-modal';

@inject('userStore')
@observer
class Events extends Component {
  //TODO - send payment options, pass the stripe public key
    constructor(props){
        super(props);
        this.state = {
            events:[],
            public_key:'',
            visible:false,
            component:null,
            invoice:null,
            paymentOptionList:[],
            selectedEvent:null
        }
        this.modalBackgroundClicked = this.modalBackgroundClicked.bind(this);
        this.modalHandler = this.modalHandler.bind(this);
        this.saveInspiration = this.saveInspiration.bind(this);
        this.fetchEvents = this.fetchEvents.bind(this);
    }

    onToken = (token) => {
      post('v2/post/stripe_payment_process', {stripe:token, hash_id:this.state.invoice.hash_id, bk_payment_hash_id:this.state.invoice.bk_payment_hash_id}, {
              auth: {username: this.props.userStore.token}
          }).then((res) => {
            if (res.data.errors === 0){
              let temp_events = Object.assign([], this.state.events);
              let index = temp_events.findIndex(x => x.id === this.state.selectedEvent.id);
              let inv_index = temp_events[index].invoice_list.findIndex(x => x.id === this.state.invoice.id);
              let temp_event = Object.assign({}, temp_events[index]);
              let temp_invoice_list = Object.assign([], temp_event.invoice_list);
              temp_invoice_list[inv_index] = res.data.invoice;
              temp_event.invoice_list = temp_invoice_list;
              temp_events[index] = temp_event;
              this.setState({
                // update the particular invoice and set state
                  events:temp_events,
                  visible:!this.state.visible
              }, ()=>console.log(this.state.events));
            }
        }).catch((error) => {
              return error;
        });
    }

    componentDidMount(){
        this.fetchEvents();
    }


    modalBackgroundClicked(){
        this.setState({
            visible:!this.state.visible, component:null
        });
    }

    saveInspiration(inspiration, event, mode){
      post('v2/save/inspiration', {booking_id:event.id, mode:mode, inspiration:inspiration}, {
              auth: {username: this.props.userStore.token}
          }).then((res) => {
            if (res.data.errors === 0){
              // add the new inspiration
              let temp_events = Object.assign([], this.state.events);
              let index = temp_events.findIndex(x => x.id === this.state.selectedEvent.id);
              let temp_event = Object.assign({}, temp_events[index]);
              let temp_inspiration_list = Object.assign([], temp_event.inspiration_list);
              if (mode === 'add'){
                temp_inspiration_list.push(res.data.inspiration);
              } else {
                let insp_index = temp_inspiration_list.findIndex(x => x.id === inspiration.id);
                delete temp_inspiration_list[insp_index];
                console.log(temp_inspiration_list);
              }
              temp_event.inspiration_list = temp_inspiration_list;
              temp_events[index] = temp_event;
              if (res.data.mode == 'add'){
                this.setState({
                    events:temp_events,
                    visible:!this.state.visible,
                    component:null
                }, ()=>notify.show(res.data.message, "success", 3000));
              } else {
                this.setState({
                    events:temp_events,
                    component:null
                }, ()=>notify.show(res.data.message, "success", 3000));
              }
            } else {
              this.setState({
                  visible:!this.state.visible
              }, ()=>notify.show(res.data.message, "error", 3000));

            }
        }).catch((error) => {
          if (error.response && error.response.status === 401){
              this.props.userStore.logout();
          }
          return error;
        });

    }

    modalHandler(invoice, component, event){
        this.setState({
            invoice:invoice,
            visible:!this.state.visible,
            paymentOptionList:event.payment_option_list,
            selectedEvent:event,
            component:component
        })
    }


    fetchEvents(){
        post('v2/get/client_events', {}, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              if (res.data.errors === 0){
                  this.setState({
                      events:res.data.events,
                      public_key:res.data.public_key
                  })
              } else {
                  notify.show(res.data.message, "error", 1000);
              }
          }).catch((error) => {
            if (error.response && error.response.status === 401){
                this.props.userStore.logout();
            }
            return error;
          });
    }



    render() {
        if (this.state.events.length === 0) return <div className="main-content container"><div className="row"><div className="col-lg-12">Loading</div></div></div>;
        const {invoice, component, paymentOptionList, public_key} = this.state;
        return (
            <React.Fragment>
              <Modal visible={this.state.visible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg w-900px">
                  {this.state.component ? <this.state.component invoice={invoice} paymentOptionList={paymentOptionList} token_handler={this.onToken} modalBackgroundHandler={this.modalBackgroundClicked} public_key={public_key} saveInspiration={this.saveInspiration} event={this.state.selectedEvent}/>:<React.Fragment></React.Fragment>}
              </Modal>
              <Notifications />
              <div className="main-content container">
              {this.state.events.map((event, index) =>
                  <Event event={event} key={index} modalHandler={this.modalHandler} saveInspiration={this.saveInspiration}/>
              )}
              </div>
            </React.Fragment>
        );
    }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/client/Events.js